import { render } from "./add-chapter.vue?vue&type=template&id=54fc1f1e"
import script from "./add-chapter.vue?vue&type=script&lang=js"
export * from "./add-chapter.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__